<template>
	<div class="error">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div class="contentcard">
						<div style="text-align: center;top: 20%;position: relative;">
							<p style="font-size: 100px;color: #4b505d;margin: 0;">403</p>
							<p style="font-size: 20px;color: rgba(0,0,0,.45);">抱歉，您无权访问该页面或执行该操作</p>
							<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="()=>{this.$router.push('mainpage')}">返回首页</a-button>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				current: [''],
				openKeys: ['']
			}
		}

	};
</script>

<style>

	.error .contentcard {
		padding: 24px;
		background-color: #fff;
		height: 100%;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?6e6354d8